module.exports = __webpack_public_path__ + "static/img/Ownership-Penetration.eae333d0.gif";